import { createAsyncThunk } from '@reduxjs/toolkit';
import { batch } from 'react-redux';

import { authSet } from '../../../utils/request';
import { METHOD_POST } from '../../../constants/api';
import { setOrderedParts } from '../../../actions/coilovers/orderedParts/patchOrderedParts';
import getAcceptanceDelays from '../acceptance/getAcceptanceDelays';
import getAcceptanceToDay from '../acceptance/getAcceptanceToDay';

const deliveredOrderedParts = createAsyncThunk('orderedParts/patchOrderedParts',
  async ({ _id, formData } = {}, { rejectWithValue, getState, dispatch }) => {
  const {
    getAcceptanceToDay: { data: acceptanceToDay },
    getAcceptanceDelays: { data: acceptanceDelays }
  } = getState();
    try {
      const { data } = await authSet(METHOD_POST, `/co/ordered_parts/${_id}/delivered`, formData);
      batch(() => {
        dispatch(setOrderedParts(data));
        if (acceptanceDelays.length) {
          dispatch(getAcceptanceDelays());
        }
        if (acceptanceToDay.length) {
          dispatch(getAcceptanceToDay());
        }
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default deliveredOrderedParts;
